import BreakHoursForMinors from './BreakHoursForMinors';

export default BreakHoursForMinors;
